import React from 'react';
import SVG from '@app/components/SVG';
import shieldCheck from '@app/images/shieldCheck.svg';
import shieldOff from '@app/images/shieldOff.svg';
import lock from '@app/images/lock.svg';
import { SergeeMetricResult } from '@mortee/domain/morteeAccountVerification';

interface RowStatusIconProps {
  status: SergeeMetricResult;
}

const RowStatusIcon: React.FC<RowStatusIconProps> = ({ status }) => {
  if (status === SergeeMetricResult.Match) {
    return (
      <SVG
        accessibilityLabel={SergeeMetricResult.Match}
        image={shieldCheck}
        height={18}
        className='fill-green-600 text-green-600'
      />
    );
  }
  if (status === SergeeMetricResult.KnoxValidationRequired) {
    return (
      <SVG
        accessibilityLabel={SergeeMetricResult.KnoxValidationRequired}
        image={lock}
        height={18}
        className='fill-gray-400 text-gray-400'
      />
    );
  }

  return <SVG accessibilityLabel={status} image={shieldOff} height={18} />;
};

export default RowStatusIcon;
